import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=dbb3629c&scoped=true&"
import script from "./BanksList.vue?vue&type=script&lang=js&"
export * from "./BanksList.vue?vue&type=script&lang=js&"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=dbb3629c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb3629c",
  null
  
)

export default component.exports